/**
 * RewriteSkillsOutput — renders the rewrite_skills step: the reordered skills,
 * skills to add / remove, and the ATS keyword set — all as chip clusters.
 */

import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import type { ResumeStepData } from "../../../api/client";
import LessonMarkdown from "../../LessonMarkdown";
import { ChipSection } from "./shared";

export default function RewriteSkillsOutput({ step }: { step: ResumeStepData }) {
  const theme = useTheme();
  const { t } = useTranslation("resume");
  const o = step.output ?? {};

  return (
    <Stack spacing={2.5}>
      <ChipSection label={t("RewriteSkillsOutput.reorderedSkills")} items={o.reordered_skills} />
      <ChipSection label={t("RewriteSkillsOutput.skillsToAdd")} items={o.skills_to_add} color={theme.palette.success.main} />
      <ChipSection label={t("RewriteSkillsOutput.skillsToRemove")} items={o.skills_to_remove} color={theme.palette.error.dark} />
      <ChipSection label={t("RewriteSkillsOutput.atsKeywords")} items={o.ats_keywords} variant="outline" />

      <LessonMarkdown>{step.narrative_markdown ?? ""}</LessonMarkdown>
    </Stack>
  );
}
